import React from 'react'
import { PerformanceReportsVM } from '../../Structure/ViewModels/Admin/PerformanceReportsVM'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { Container, Row } from 'react-bootstrap'
import ClientsWithRemainingMoney from './ClientsWithRemainingMoney'
import ShippmentsReport from './ShippmentsReport'
import { Globals } from '../../Structure/Globals/GlobalObs'
import ClientsSheet from './ClientsSheet'
import TransactionsSheet from './TransactionsSheet'
import AccountsSheet from './AccountsSheet'

const PerformanceReports = () => {
    const control = useVM<PerformanceReportsVM>(new PerformanceReportsVM())
    
  return (
    <Container>
        <Row>
            <div className='d-flex justify-content-start'>
                {  
                    Globals.auth.User?.permissions.some(a=>a.id=='32')?(
                    <div className='px-3'>
                        <button className={`button-I ${control.Active==0?'btn-cl-II':'btn-cl-I'} py-2 px-4`} onClick={()=> control.setContent(ClientsWithRemainingMoney,0) } >عملاء متبقي عليهم دفعات</button>
                    </div>
                    ):(null)
                }
                {
                    Globals.auth.User?.permissions.some(a=>a.id=='26')?(
                        <div className='px-3'>
                        <button className={`button-I ${control.Active==1?'btn-cl-II':'btn-cl-I'} py-2 px-4`} onClick={()=>control.setContent(ShippmentsReport,1)} >الشحنات</button>
                    </div>
                    ):(null)
                }
                {
                    Globals.auth.User?.permissions.some(a=>a.id=='33')?(
                        <div className='px-3'>
                        <button className={`button-I ${control.Active==2?'btn-cl-II':'btn-cl-I'} py-2 px-4`} onClick={()=>control.setContent(ClientsSheet,2)} >شيت العملاء</button>
                    </div>
                    ):(null)
                }
                {
                    Globals.auth.User?.permissions.some(a=>a.id=='34')?(
                        <div className='px-3'>
                        <button className={`button-I ${control.Active==3?'btn-cl-II':'btn-cl-I'} py-2 px-4`}  onClick={()=>control.setContent(TransactionsSheet,3)} >شيت التحويلات المالية</button>
                    </div>
                    ):(null)
                }
                {
                    Globals.auth.User?.permissions.some(a=>a.id=='35')?(
                        <div className='px-3'>
                        <button className={`button-I ${control.Active==4?'btn-cl-II':'btn-cl-I'} py-2 px-4`}  onClick={()=>control.setContent(AccountsSheet,4)} >شيت حسابات التحويل </button>
                    </div>
                    ):(null)
                }
            </div>
        </Row>
        <Row>
            <div>
                {control.Element}
            </div>
        </Row>
    </Container>
  )
}

export default PerformanceReports
